window.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
function hideConsoles() {

  if (process.env.NODE_ENV === "production") {
    console.log = () => { };
    console.warn = () => { };
    console.error = () => { };
    console.info = () => { };
    console.debug = () => { };
  }
}

hideConsoles(); // Call early
import { createApp } from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import router from "./router";
import { Amplify } from "aws-amplify";
import store from "./store";
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';
loadFonts();
async function initApp() {
  Amplify.configure({
    Auth: {
      Cognito: {
        identityPoolId: process.env.VUE_APP_AWS_IDENTITY_POOL_ID,
        userPoolId: process.env.VUE_APP_AWS_COGNITO_USER_POOL_ID,
        userPoolClientId: process.env.VUE_APP_AWS_USER_POOL_WEB_CLIENT_ID,
        // signUpVerificationMethod: "code",
        loginWith: {
          email: true,
        },
      },
    },

    API: {
      GraphQL: {
        endpoint: process.env.VUE_APP_AWS_APPSYNC_GRAPHQL_ENDPOINT,
        region: process.env.VUE_APP_AWS_APPSYNC_REGION,
        defaultAuthMode: process.env.VUE_APP_AWS_AUTHENTICATION_TYPE,
      },
    },

    Storage: {
      S3: {
        bucket: process.env.VUE_APP_AWS_S3_BUCKET_NAME,
        region: process.env.VUE_APP_AWS_REGION,
      },
    },
  });
  // console.log("Amplify configuration:", Amplify);
}

initApp().then(() => {
  createApp(App)
    .use(router)
    .use(store)
    .use(vuetify)
    .use(VueTelInput)
    .mount("#app");
});
